export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/plane.e760f685-ac2215.png";